module.exports = __webpack_public_path__ + "static/media/instagram.dd22a9f0.svg";